/** @format */

import React, { FunctionComponent, ReactElement } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import { ServiceTemplateItems } from './ServiceTemplateEdit';
import GridItem from '../../components/Grid/GridItem';
import DeleteButton from '../../components/Buttons/DeleteButton';
import { Typography } from '@material-ui/core';

const _ = require('underscore');

type ServiceTempateElementListType = {
    serviceTemplate: ServiceTemplateItems;
    deleteCallback(service: string): void;
};

export const ServiceTempateElementList: FunctionComponent<ServiceTempateElementListType> = ({ serviceTemplate, deleteCallback }): ReactElement => {
    const processItems = (
        item: { [key: string]: { verb: string; param: Array<{ name: string; value: string | number }> } },
        index: number
    ): ReactElement => {
        const key = Object.keys(item)[0];
        return (
            <React.Fragment key={'item_map_template_' + index}>
                <GridItem xs={2}>
                    <DeleteButton callback={(): void => deleteCallback(key)} callbackParam={{}} tooltipTitle="prov:feature.delete_feature" />
                </GridItem>
                <GridItem xs={4}>
                    <Typography variant="subtitle2">{key}</Typography>
                </GridItem>
                <GridItem xs={12}>
                    <GridContainer>
                        <GridItem xs={2}>{item[key].verb}</GridItem>
                        <GridItem xs={6}>{item[key].param && getItemParams(key, item[key].param)}</GridItem>
                    </GridContainer>
                    <hr />
                </GridItem>
            </React.Fragment>
        );
    };

    const getItemParams = (key: string, params: Array<{ name: string; value: string | number }>): ReactElement => {
        const elem = params.map((item, index) => {
            return (
                <GridContainer key={key + index + item.name + item.value}>
                    <GridItem xs={4}>{item.name}</GridItem>
                    <GridItem xs={8}>{item.value}</GridItem>
                </GridContainer>
            );
        });
        return <React.Fragment>{elem}</React.Fragment>;
    };

    return (
        <GridContainer>
            {serviceTemplate.components.map((item, index) => {
                return processItems(item, index);
            })}
        </GridContainer>
    );
};
